export default "<app-main-nav></app-main-nav>\n<router-outlet></router-outlet>\n"